import { render, staticRenderFns } from "./InputCard.vue?vue&type=template&id=f9c23e5a&scoped=true&"
import script from "./InputCard.vue?vue&type=script&lang=js&"
export * from "./InputCard.vue?vue&type=script&lang=js&"
import style0 from "./InputCard.vue?vue&type=style&index=0&id=f9c23e5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c23e5a",
  null
  
)

export default component.exports